import React, { useEffect } from "react";
import { TextDescription, TextHeader } from "components/Texts";
import { useDispatch, useSelector } from "react-redux";

import Column from "components/Column";
import Row from "components/Row";
import Section from "components/Section";
import TextSubscript from "components/TextSubscript";
import formatMoney from "modules/utils/formatMoney";
import mainSelectors from "modules/main/selectors";
import paymentAction from "modules/payment/actions";
import paymentSelectors from "modules/payment/selectors";
import styled from "styled-components";
import useCurrency from "modules/utils/useCurrency";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../layout/useWindowSize";

const BudgetSummary = () => {
  const remainingBudgetList = useSelector((state) => paymentSelectors.remainingBudgetList(state));
  const currentAd = useSelector((state) => mainSelectors.currentAd(state));
  const avgUsage = useSelector((state) => paymentSelectors.avgUsage(state));
  const dispatch = useDispatch();
  const daysToExhaust = parseInt(remainingBudgetList.remainingBudget / avgUsage);

  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();
  const windowSize = useWindowSize();
  const updateTime = `${t("__updated")} ${remainingBudgetList.lastUpdate}`;
  const fixedAvg = parseFloat(avgUsage).toFixed(2);
  console.log("remainingBudgetList", remainingBudgetList);
  const rBudget = {
    value: remainingBudgetList.creditCard
      ? "-"
      : formatMoney(
          parseFloat(isNaN(remainingBudgetList.remainingBudget) ? 0 : remainingBudgetList.remainingBudget).toFixed(2),
        ),
    unit: useCurrency(),
  };
  const avgDailySpend = {
    value: remainingBudgetList.creditCard ? "-" : isNaN(fixedAvg) ? "0.00" : fixedAvg,
    unit: useCurrency(),
  };
  const estDaysToExhaust = {
    value: remainingBudgetList.creditCard ? "-" : daysToExhaust || "0",
    unit: remainingBudgetList.creditCard ? "" : t("__days"),
  };

  useEffect(() => {
    //const cusId = '218-381-9373' //test
    const cusId = currentAd.ads_account_id;
    dispatch(paymentAction.GetRemainingBudgetList(cusId));
    dispatch(paymentAction.GetAVGUsage(cusId));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAd]);

  const desktopView = () => {
    return (
      <Section margin="0 0 24px" padding="16px 24px 24px">
        <TextDescription align="right">{updateTime}</TextDescription>
        <Row alignItems="stretch">
          <Column wrap>
            <StyledIconSign>฿</StyledIconSign>
          </Column>
          <Column>
            <BudgetSummaryItem
              value={rBudget.value}
              unit={rBudget.unit}
              description={t("__remaining_budget")}
              textSize="24px"
            />
          </Column>
          <Column>
            <BudgetSummaryItem
              value={remainingBudgetList.creditCard ? "-" : formatMoney(avgDailySpend.value)}
              unit={avgDailySpend.unit}
              description={t("__avg_daily_spend")}
              subscriptSize="10px"
            />
          </Column>
          <Column>
            <BudgetSummaryItem
              value={estDaysToExhaust.value}
              unit={estDaysToExhaust.unit}
              description={t("__estimated_exhaust")}
              subscriptSize="10px"
            ></BudgetSummaryItem>
          </Column>
        </Row>
      </Section>
    );
  };

  const mobileView = () => {
    return (
      <ContainerMobile>
        <Row className="row" alignItems="center" justifyContent="space-between !important">
          <Column wrap>
            <TextHeader>฿</TextHeader>
          </Column>
          <Column wrap>
            <BudgetSummaryItem
              value={rBudget.value}
              unit={rBudget.unit}
              description={t("__remaining_budget")}
              textSize="24px"
            ></BudgetSummaryItem>
          </Column>
        </Row>
      </ContainerMobile>
    );
  };

  return windowSize.width > 834 ? desktopView() : mobileView();
};

export default BudgetSummary;

const BudgetSummaryItem = ({ value, unit, description, textSize, subscriptSize }) => {
  return (
    <div className="budget-item">
      <TextSubscript
        valueText={value}
        subscriptText={unit}
        valueSize={textSize}
        subscriptSize={subscriptSize}
      ></TextSubscript>
      <TextDescription>{description}</TextDescription>
    </div>
  );
};

const ContainerMobile = styled(Section)`
  margin: 0 40px 24px !important;
  & > .row {
    justify-content: center;
  }
`;

const StyledIconSign = styled(TextHeader)`
  font-size: 40px;
  padding: 0px 24px 0px 12px;
`;
